import { envConfig } from '../../envConfig'

const webUrlBase = envConfig.url.API_URL

export const urlGetOrdersHistory = `${webUrlBase}api/mobile/users/user_orders_history`
export const urlCloneOrder = `${webUrlBase}api/mobile/table_orders/clone_order`
